var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27325 10.6666H11.7266C11.8584 10.666 11.9872 10.6264 12.0965 10.5527C12.2058 10.479 12.2908 10.3745 12.3408 10.2525C12.3907 10.1304 12.4034 9.99635 12.3771 9.86714C12.3508 9.73794 12.2869 9.61941 12.1932 9.52657L8.47325 5.80657C8.41127 5.74409 8.33754 5.69449 8.2563 5.66065C8.17506 5.6268 8.08792 5.60937 7.99991 5.60938C7.91191 5.60937 7.82477 5.6268 7.74353 5.66065C7.66229 5.69449 7.58856 5.74409 7.52658 5.80657L3.80658 9.52657C3.71297 9.61941 3.64898 9.73794 3.62273 9.86714C3.59647 9.99635 3.60912 10.1304 3.65907 10.2525C3.70902 10.3745 3.79403 10.479 3.90335 10.5527C4.01267 10.6264 4.1414 10.666 4.27325 10.6666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caretUp.922604b1f5e2a5712bd783ccaa7540c5.svg";
export { ForwardRef as ReactComponent };